<template>
  <div class="tabbar">
    <router-link
      v-for="item in tabs"
      :key="item.path"
      :to="item.path"
      class="tabbar-item"
      active-class="active"
    >
      <i :class="item.icon" class="tabbar-icon"></i>
      <span class="tabbar-label">{{ item.label }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  data() {
    return {
      tabs: [
        { path: '/home', label: '首页', icon: 'el-icon-house' },
        { path: '/order-hall', label: '订单大厅', icon: 'el-icon-s-order' },
        { path: '/mine', label: '我的', icon: 'el-icon-user' }
      ]
    }
  }
}
</script>

<style scoped>
.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  display: flex;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  z-index: 200;
}

.tabbar-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  transition: color 0.2s;
}

.tabbar-item.active {
  color: #4a90e2;
}

.tabbar-icon {
  font-size: 22px;
  margin-bottom: 2px;
}

.tabbar-label {
  font-size: 11px;
}
</style>
